import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import AuthProvider from './features/auth/AuthProvider';
import MessageCenter from './components/ui/messages/MessageCenter';
import ModalManager from './components/ui/ModalManager';
import ErrorBoundary from './components/ui/ErrorBoundary';
import AppRoutes from './routes';
import './styles/global.css';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

//  Make queryClient available globally for cleanup during logout
window.queryClient = queryClient;

function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <Router>
          <AuthProvider>
            <MessageCenter />
            <ModalManager />
            <AppRoutes />
            <Toaster position="top-right" />
          </AuthProvider>
        </Router>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
